(() => {
  if(customElements.get('pp-treatment-complete'))return;
  class Treatment extends HTMLElement {
    connectedCallback(){
      this.controller=new AbortController();const options={signal:this.controller.signal};
      this.form=this.querySelector('form');this.rows=[...this.querySelectorAll('[data-pairing-row]')];
      this.money=new Intl.NumberFormat(this.dataset.locale||'nl-NL',{style:'currency',currency:this.dataset.currency||'EUR'});
      this.form.addEventListener('change',()=>this.update(),options);this.form.addEventListener('input',()=>this.update(),options);
      this.form.addEventListener('submit',e=>{e.preventDefault();this.add();},options);this.update();
    }
    disconnectedCallback(){this.controller?.abort();}
    selected(){return this.rows.filter(row=>row.querySelector('[data-pairing-check]').checked);}
    update(){let total=0;const selected=this.selected();let valid=true;for(const row of selected){const input=row.querySelector('input[type=number]');valid&&=input.validity.valid;total+=Number(row.dataset.price)*Number(input.value);}this.querySelector('[data-pairing-total]').textContent=this.money.format(total/100);this.form.querySelector('[type=submit]').disabled=this.busy||this.uncertain||!selected.length||!valid;}
    async add(){
      if(this.busy||this.uncertain||!this.form.reportValidity())return;
      const selected=this.selected();if(!selected.length)return;
      const data=new FormData();selected.forEach((row,i)=>{data.append(`items[${i}][id]`,row.dataset.variant);data.append(`items[${i}][quantity]`,row.querySelector('input[type=number]').value);});
      this.busy=true;this.update();const status=this.querySelector('[data-pairing-status]');status.textContent='Je selectie wordt toegevoegd…';
      try{
        await window.ppCartAdd(data);selected.forEach(row=>row.querySelector('[data-pairing-check]').checked=false);
        status.textContent='Je selectie is toegevoegd aan je winkelwagen.';this.querySelector('[data-pairing-cart]').hidden=false;
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{source:'pp-treatment-complete'}}));
        try{await window.ppRefreshCartPopup?.({title:'Je aanvullingen'});}catch{}
      }catch(error){
        // Never blindly repeat a possibly successful multi-item request.
        this.uncertain=true;status.textContent='De toevoeging kon niet worden bevestigd. Controleer je winkelwagen voordat je opnieuw bestelt.';this.querySelector('[data-pairing-cart]').hidden=false;
      }finally{this.busy=false;this.update();}
    }
  }
  customElements.define('pp-treatment-complete',Treatment);
})();
